// ============================================================
// WoundsToKillChart - Survival curve (attacks vs survival %), in gold.
// ============================================================
import type { WoundsToKillEstimate } from '../../engine/probability';
import SurvivalCurveChart from './SurvivalCurveChart';

export default function WoundsToKillChart({ data }: { data: WoundsToKillEstimate }) {
  return <SurvivalCurveChart data={data} colour="#c4a35a" />;
}
